module.exports = __webpack_public_path__ + "img/ES.dd1a2e68.png";